export const RI_AP_TEXT = `RI Allocated Pension`

export const RI_TTR_TEXT = `Transition to Retirement Pension`

/**
 * Where possible use the planName on the accountbalance
 * type as that will also handle the Ri types.
 *
 * See 'addPlanNameAndTTR' method in linkApi which references this
 */
export const productIds = {
  10: "Gold State Super",
  15: "Gold State Super deferred",
  30: `${RI_AP_TEXT}|${RI_TTR_TEXT}`,
  40: "RI Term Allocated Pension",
  50: "GESB Super",
  70: "West State Super",
} as const

export const planNameSortOrder = [
  RI_AP_TEXT, // RI AP
  RI_TTR_TEXT, // RI TAP
  "Gold State Super", // GSS
  "GESB Super", // GSU
  "West State Super", // WSS
  "Transition to Retirement Pension", // RI TTR
  "Gold State Super deferred", // Deferred
] as const

export const investmentOptionsSortOrder = [
  "Australian Shares",
  "International Shares",
  "Property",
  "Fixed Interest",
  "Cash",
] as const

export const GSS_PRODUCT_ID = 10
export const DEFERRED_PRODUCT_ID = 15
export const RI_AP_TTR_PRODUCT_ID = 30
export const RI_TAP_PRODUCT_ID = 40
export const GSU_PRODUCT_ID = 50
export const WSS_PRODUCT_ID = 70

export const NON_RI_ACCOUNTS = [
  WSS_PRODUCT_ID,
  GSU_PRODUCT_ID,
  GSS_PRODUCT_ID,
  DEFERRED_PRODUCT_ID,
] as const

export const RI_ACCOUNTS = [RI_AP_TTR_PRODUCT_ID, RI_TAP_PRODUCT_ID] as const

export const GSS_ACCOUNTS = [GSS_PRODUCT_ID, DEFERRED_PRODUCT_ID] as const

export const WSS_GSU_ACCOUNTS = [GSU_PRODUCT_ID, WSS_PRODUCT_ID] as const

// Link/ProductApi banking-details-get only accepts accumulation + RI, not GSS 10/15
export const BANKING_DETAILS_PRODUCTS = [
  ...RI_ACCOUNTS,
  ...WSS_GSU_ACCOUNTS,
] as const
export type BankingDetailsProductId = (typeof BANKING_DETAILS_PRODUCTS)[number]

// special field codes
export const SF_CODE_FREQUENCY = "PORTREBALFREQ"
export const SF_CODE_STATUS = "PORTREBALSTATUS"

// special codes PYS
export const SF_PYS_WARNING_FLAG = "PYS_INS_WARNING"
export const SF_PYS_CANCEL_DATE = "PYS_INS_CANCEL"
export const SF_PYS_ELECTION_FLAG = "PYS_INS_ELECT"

export const PIE_GRAPH_COLOURS = [
  "blue",
  "purple",
  "red",
  "green",
  "orange",
  "pink",
] as const

export const SCI_POLICY_PERIOD = 120
export const SCI_POLICY_PERIOD_DAYS = " days"
export const SCI_POLICY_PERIOD_READABLE = 120 + SCI_POLICY_PERIOD_DAYS

export const ALL_GENDERS = [
  {
    readable: "Male",
    code: "M",
  },
  {
    readable: "Female",
    code: "F",
  },
] as const

export const FORM_OCCUPATIONS = {
  1: "White Collar",
  2: "Light Blue Collar",
  3: "Blue Collar/Heavy Blue Collar",
  4: "Hazardous occupations",
  5: "Professional and Executive",
} as const

export const GSU_WSS_TRANSACTIONS = [
  "EmployerContributions",
  "SalarySacrificeContributions",
  "PersonalContributions",
  "RolledInFromOtherFunds",
  "OtherContributions",
  "InsurancePremiums",
  "Fees",
  "PartialPayments",
  "OtherPayments",
] as const

export const RI_TRANSACTIONS = [
  "RolledInFromOtherFunds",
  "IncomePayments",
  "PartialPayments",
  "OtherPayments",
  "Fees",
] as const

export const GSS_TRANSACTIONS = [
  "SalarySacrificeContributions",
  "PersonalContributions",
  "OtherPayments",
] as const

export const VALID_BROWSERS = {
  Chrome: 109,
  Firefox: 109,
  Edge: 109,
  Safari: 15,
  "Mobile Safari": 15,
  Opera: 94,
  "Internet Explorer": null,
  IE: null,
} as const

export const AU_STATES = {
  ACT: "Australian Capital Territory",
  NSW: "New South Wales",
  NT: "Northern Territory",
  QLD: "Queensland",
  SA: "South Australia",
  TAS: "Tasmania",
  VIC: "Victoria",
  WA: "Western Australia",
} as const

export const AU_STATES_LIST = [
  AU_STATES.ACT,
  AU_STATES.NSW,
  AU_STATES.NT,
  AU_STATES.QLD,
  AU_STATES.SA,
  AU_STATES.TAS,
  AU_STATES.VIC,
  AU_STATES.WA,
] as const

export const PENSION_PAYMENTS_FORM_AGE_MIN = 60

export const RETIREMENT_AGE = 65

export const PERSIST_FORMS_SESSION_KEY = "GESBMOL_PersistForms"

export const SUBMISSION_PREVENTED_MESSAGE = "Submission has been prevented"
